/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';

import { Subject, takeUntil } from 'rxjs';

import { CoreConfigService } from '../../../services';
import { CoreSidebarService } from '../../core-sidebars/core-sidebar/services/core-sidebar.service';

@Component({
  selector: 'xbaht-core-theme-customizer',
  templateUrl: './theme-customizer.component.html',
  styleUrl: './theme-customizer.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class CoreThemeCustomizerComponent implements OnInit, OnDestroy {
  public navbarColorValue?: string;
  public coreConfig: any;
  public form!: FormGroup;

  private _unsubscribe: Subject<void>;

  constructor(
    private _formBuilder: FormBuilder,
    private _coreConfigService: CoreConfigService,
    private _coreSidebarService: CoreSidebarService
  ) {
    this._unsubscribe = new Subject<void>();
  }

  ngOnInit(): void {
    this.form = this._formBuilder.group({
      app: this._formBuilder.group({
        appName: new FormControl(),
        appTitle: new FormControl(),
        appLogoImage: new FormControl(),
        appLanguage: new FormControl(),
      }),
      layout: this._formBuilder.group({
        skin: new FormControl(),
        type: new FormControl(),
        animation: new FormControl(),
        menu: this._formBuilder.group({
          hidden: new FormControl(),
          collapsed: new FormControl(),
        }),
        navbar: this._formBuilder.group({
          hidden: new FormControl(),
          type: new FormControl(),
          background: new FormControl(),
          customBackgroundColor: new FormControl(),
          backgroundColor: new FormControl(),
        }),
        footer: this._formBuilder.group({
          hidden: new FormControl(),
          type: new FormControl(),
          background: new FormControl(),
          customBackgroundColor: new FormControl(),
          backgroundColor: new FormControl(),
        }),
        enableLocalStorage: new FormControl(),
        customizer: new FormControl(),
        scrollTop: new FormControl(),
        buyNow: new FormControl(),
      }),
    });

    this._coreConfigService.config
      .pipe(takeUntil(this._unsubscribe))
      .subscribe((config: any) => {
        this.coreConfig = config;

        this.form.setValue(config, { emitEvent: false });
      });

    this.form
      .get('layout.type')
      ?.valueChanges.pipe(takeUntil(this._unsubscribe))
      .subscribe((value: any) => {
        this._resetFormValues(value);
      });

    this.form.valueChanges
      .pipe(takeUntil(this._unsubscribe))
      .subscribe((config: any) => {
        this._coreConfigService.config = config;
      });

    this.navbarColor(this.form.get('layout.navbar.backgroundColor')?.value);
  }

  ngOnDestroy(): void {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }

  private _resetFormValues(value: any): void {
    switch (value) {
      case 'vertical':
        this.form.patchValue({
          layout: {
            // skin: 'default',
            animation: 'fadeIn',
            menu: {
              hidden: false,
              collapsed: false,
            },
            navbar: {
              hidden: false,
              type: 'floating-nav',
              background: 'navbar-light',
              customBackgroundColor: true,
              backgroundColor: '',
            },
            footer: {
              hidden: false,
              type: 'footer-static',
              background: 'footer-light',
              customBackgroundColor: false,
              backgroundColor: 'bg-primary',
            },
          },
        });
        break;
      case 'horizontal':
        this.form.patchValue({
          layout: {
            // skin: 'default',
            animation: 'fadeIn',
            menu: {
              hidden: false,
              collapsed: false,
            },
            navbar: {
              hidden: false,
              type: 'floating-nav',
              background: 'navbar-light',
              customBackgroundColor: true,
              backgroundColor: '',
            },
            footer: {
              hidden: false,
              type: 'footer-static',
              background: 'footer-light',
              customBackgroundColor: false,
              backgroundColor: 'bg-primary',
            },
          },
        });
        break;
    }

    this.navbarColor(this.form.get('layout.navbar.backgroundColor')?.value);
  }

  public navbarColor(value: string): void {
    this.navbarColorValue = value;
    this.form.patchValue({
      layout: {
        navbar: {
          customBackgroundColor: true,
          backgroundColor: this.navbarColorValue,
        },
      },
    });
  }

  public toggleSidebar(key: any): void {
    this._coreSidebarService.getSidebarRegistry(key)?.toggleOpen();
  }
}
